import {
  captureAppError,
  captureAppMessage,
} from '@leagueplatform/observability';

export const SENTRY_CONSTANTS = {
  OWNERSHIP_TEAM: 'highmark-solutions',
};

export const AUTH0_ERROR_TYPES = {
  LOGIN_REQUIRED: 'login_required',
};

export const captureAuthenticationError = (error: {
  type: string;
  description: string | null;
}) => {
  if (
    error.type &&
    error.type.toLowerCase().includes(AUTH0_ERROR_TYPES.LOGIN_REQUIRED)
  ) {
    // If the error message is due to the user timing out, then we would like to capture this
    // as a warning on Sentry, all other use cases should be handled as an error
    captureAppMessage(`Auth0 Error - ${error.type}`, {
      context: {
        Context: {
          info: `User has been logged out due to inactivity, a new login is required - type: ${error.type}, description: ${error.description}`,
        },
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      severityLevel: 'warning',
    });
  } else {
    captureAppError(new Error(error.type), {
      errorName: `Auth0 Error - ${error.type}`,
      context: {
        Context: {
          info: `an authentication error has occurred - type: ${error.type}, description: ${error.description}`,
        },
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
    });
  }
};
